import {
  planningClient as createPlanningClient,
  type NutritionPlannerRequest,
  type NutritionPlannerResponse,
} from '../../../backend/src/client';
import { apiFetch } from './apiClient';

const plannerApiFetch = (input: string, init: RequestInit = {}) => {
  return apiFetch(input, init);
};

type PlanningApiClient = {
  generate: {
    $post(args: { json: NutritionPlannerRequest }): Promise<Response>;
  };
};

const client = createPlanningClient(plannerApiFetch) as PlanningApiClient;

export type NutritionPlannerClient = {
  generatePlan(input: NutritionPlannerRequest): Promise<NutritionPlannerResponse>;
};

const parsePlannerErrorMessage = async (response: Response): Promise<string> => {
  try {
    const payload = (await response.clone().json()) as {
      message?: unknown;
      error?: unknown;
    };
    if (typeof payload.message === 'string' && payload.message.trim().length > 0) {
      return payload.message;
    }
    if (typeof payload.error === 'string' && payload.error.trim().length > 0) {
      return payload.error;
    }
  } catch {
    // Ignore malformed error payloads and fallback to a generic error message.
  }

  return `Nutrition planning request failed (${response.status})`;
};

export const nutritionPlannerClient: NutritionPlannerClient = {
  async generatePlan(input: NutritionPlannerRequest): Promise<NutritionPlannerResponse> {
    const response = await client.generate.$post({ json: input });
    const body = (await response.json()) as NutritionPlannerResponse;

    if (!response.ok && body.status !== 'conflict') {
      throw new Error(await parsePlannerErrorMessage(response));
    }

    return body;
  },
};
